module.exports = __webpack_public_path__ + "static/media/maystro-blue-notext.d3756c84.svg";